import { render, staticRenderFns } from "./locationCommodity.vue?vue&type=template&id=973e0132&"
import script from "./locationCommodity.vue?vue&type=script&lang=js&"
export * from "./locationCommodity.vue?vue&type=script&lang=js&"
import style0 from "./locationCommodity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports